module.exports = __webpack_public_path__ + "static/img/t5-1.110aa1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t5-1.png
// module id = Qjhz
// module chunks = 1